export default __webpack_public_path__ + "static/media/facebook.49874285.png";